import styled from 'styled-components';

export const EditableLabelContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const Label = styled.span<{ isPlaceholder: boolean; light: boolean }>`
  flex: 1;
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  color: ${({ isPlaceholder, light, theme }) =>
    isPlaceholder ? theme.colours.agedGray : light ? theme.colours.white : theme.colours.black};
  font-size: ${({ theme }) => theme.pxToRem(14)};
  border-radius: 4px;
`;

export const EditPopup = styled.div`
  position: absolute;
  top: -25px;
  left: auto;
  right: 0;
  width: ${({ theme }) => theme.pxToRem(295)};
  height: ${({ theme }) => theme.pxToRem(50)};
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  font-size: ${({ theme }) => theme.pxToRem(14)};
  background: ${({ theme }) => theme.colours.white};
  border: 1px solid ${({ theme }) => theme.colours.gray};
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgb(0 0 0 / 10%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: ${({ theme }) => theme.zIndex.level_5};
  gap: 10px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 0;
`;

export const Input = styled.input`
  flex: 1;
  font-size: 14px;
  border: 1px solid ${({ theme }) => theme.colours.gray};
  border-radius: 4px;
  padding: 5px;
  outline: none;
`;

export const IconButton = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.7;
  }

  svg {
    cursor: pointer;
  }
`;

export const VerticalSeparator = styled.div`
  height: 25px;
  border: 1px solid ${({ theme }) => theme.colours.gray};
`;
